import React from 'react';
import { useRouter } from '../../../hooks/useRouter';
import { ConnectionButton } from './ConnectionButton';
import UserBadge from './UserBadge';
import { formatDistance, Pleb } from '../../../models/Pleb';
import { useConfirm } from '../../../hooks/useConfirm';
import TileList from './TileList';
import { ChatChannelType } from '../../../models/ChatChannel';

interface MemberListTileProps {
  member: Pleb;
  admin: boolean;
  onTap: () => void;
  allowPressAwaitingReply: boolean;
}

export function MemberListTile({ member, admin, onTap, allowPressAwaitingReply }: MemberListTileProps) {
  const {navigateFromFullChannelId, navigateToProfile} = useRouter();
  const {openConnectDialog} = useConfirm();

  const handleClickConnect = (e: React.MouseEvent) => {
    e.stopPropagation();
    openConnectDialog(member.toJson());
  }

  const handleTap = () => {
    navigateToProfile(ChatChannelType.Messaging, member.id);
  }

  return (
    <TileList
      onTap={handleTap}
    >
      <div className="flex items-center">
        <img
          src={member.thumbnail}
          alt="Avatar"
          className="w-[50px] h-[50px] object-cover rounded-full overflow-hidden bg-white"
        />
        
        <div className="ml-2 mr-2 flex-1 break-words [word-break:break-word]">
          <div className="flex items-center">
            <span className="font-semibold break-words [word-break:break-word]">
              {member.name}
            </span>
            
            {member.badge && (
              <div className="mx-1">
                <UserBadge badge={member.badge} />
              </div>
            )}
          </div>

          <div className="flex items-center">
            {
              member.distance && (
                <span className="text-sm opacity-50 break-words [word-break:break-word]">
                  {formatDistance(member.distance)}
                </span>
              )
            }
            
            {admin && (
              <span className="ml-1 text-xs italic text-brand-orange">
                admin
              </span>
            )}
          </div>

          {member.bio && (
            <p className="text-sm break-words [word-break:break-word]">
              {member.bio}
            </p>
          )}
        </div>

        {
          member.connection &&
            <ConnectionButton
              connection={member.connection}
              onConnect={handleClickConnect}
              onChat={(connectionId) => {
                navigateFromFullChannelId(connectionId);
              }}
              allowPressAwaitingReply={allowPressAwaitingReply}
            />
        }
      </div>
    </TileList>
  );
} 